<template>
  <div class="content is-small uploaded-file-link">
    <a
      v-if="filename !== ''"
      :href="'https://api-rfi.tianenusa.com/files/' + filename"
      target="_blank">https://api-rfi.tianenusa.com/files/{{ filename }}</a>
  </div>
</template>

<script>
export default {
  name: 'uploaded-file',
  props: {
    filename: {
      type: String,
      default: ''
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.uploaded-file-link {
  margin-top: 0.25rem;
}
</style>



// WEBPACK FOOTER //
// src/components/UploadedFile.vue